<template>
  <div>
    <main class="profile-page">
      <section class="section-profile-cover section-shaped my-0">
        <div class="shape shape-style-1 shape-primary alpha-4">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="separator separator-bottom separator-skew">
          <svg
            x="0"
            y="0"
            viewBox="0 0 2560 100"
            preserveAspectRatio="none"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon class="fill-white" points="2560 0 2560 100 0 100" />
          </svg>
        </div>
      </section>
      <section class="section">
        <div class="container">
          <div class="card card-profile shadow mt--300">
            <div class="px-4">
              <div class="row justify-content-center">
                <div class="col-lg-4 order-lg-1">
                  <div class="card-profile-stats d-flex justify-content-end">
                    <div>
                      <span class="heading">8</span>
                      <span class="description">Empleos</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 order-lg-1">
                  <div class="card-profile-image">
                    <a href="#">
                      <img
                        style="width: 67%"
                        src="../assets/img/perfil.jpg"
                        class="rounded-circle"
                      />
                    </a>
                  </div>
                </div>
                <div class="col-lg-4 order-lg-1">
                  <div
                    class="card-profile-stats d-flex justify-content-start proyectos"
                  >
                    <div>
                      <span class="heading">20</span>
                      <span class="description">Proyectos</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center quienSoy">
                <h3>Diego Vallejo B.</h3>
                <div class="h6 font-weight-300">
                  <i class="ni location_pin mr-2"></i>Ipiales, Nariño- CO
                </div>
                <div class="h6 mt-4">
                  <i class="ni business_briefcase-24 mr-2"></i>Desarrollador Web
                  - Desarrollador móvil
                </div>
                <div>
                  <i class="ni education_hat mr-2"></i>Tnlgo. Análisis y
                  Desarrollo de Sistemas de la Información
                </div>
              </div>
              <div class="border-top text-center experienciaEstudias">
                <div class="row justify-content-center">
                  <div class="card-profile-actions py-4 mt-lg-0">
                    <a
                      v-on:click="changeComponets()"
                      class="btn btn-sm btn-default btnMio float-left"
                      >Experiencia Laboral</a
                    >
                    <a
                      v-on:click="changeComponet()"
                      class="btn btn-sm btn-default btnMio btnMioEstudios"
                      >Estudios</a
                    >
                  </div>
                  <div class="col-lg-9">
                    <transition>
                      <component :is="currentPage"></component>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import Experiencia from "@/components/ExperineciaComponent.vue";
import Estudios from "@/components/EstudiosComponet.vue";

export default {
  name: "SobreMi",
  data() {
    return {
      currentPage: Experiencia,
    };
  },
  components: {
    Experiencia,
    Estudios,
  },
  methods: {
    changeComponet() {
      this.currentPage = Estudios;
    },
    changeComponets() {
      this.currentPage = Experiencia;
    },
  },
};
</script>
<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>